angular.module("events_users_profiles")

    .controller("EventsUsersProfilesListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate','$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_USERS_PROFILES_WRITE");

        $rootScope.title = $filter('translate')('events_users_profiles.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('events_users_profiles.title') }
        ];

        $scope.gridOptionsEventsUsersProfiles = {
            pdfTitle: $filter('translate')('events_users_profiles.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,             
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('events_users_profiles.name'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('events_users_profiles.button_edit'), action: 'ui-sref="events_users_profiles.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('events_users_profiles.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {             
                return Restangular.all('EventsUsersProfiles').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("events_users_profiles.edit", { id: rowEntity.id });
        }


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('events_users_profiles.button_delete'),
                message: $filter('translate')('events_users_profiles.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('EventsUsersProfiles', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('events_users_profiles.deleted_success'));
                        $scope.gridOptionsEventsUsersProfiles.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;